// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-event-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 1rem;
  min-height: 55vh;
}
.media-event-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.media-event-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.media-event-update-section .custom-container .content-section .content-body {
  margin: 2rem auto 0;
  max-width: 900px;
  border-radius: 4px;
  padding: 5rem 0.5rem;
  background: #fff;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.06);
}
@media (min-width: 768px) {
  .media-event-update-section .custom-container .content-section .content-body {
    padding: 5rem 4rem;
  }
}
.media-event-update-section .custom-container .content-section .content-body .form__div-container {
  margin-bottom: 2.5rem;
}
.media-event-update-section .custom-container .content-section .content-body .media-icon-container .media-icon {
  height: 100px;
  width: 100px;
  object-fit: contain;
}
.media-event-update-section .custom-container .content-section .content-body .media-icon-container .image-uploader {
  position: absolute;
  top: -30px;
  left: 105px;
}
.media-event-update-section .custom-container .content-section .content-body .media-icon-container .image-uploader .icon-update-btn {
  height: 40px;
  width: 40px;
  background: #b4b4b4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: 0.4s;
}
.media-event-update-section .custom-container .content-section .content-body .media-icon-container .image-uploader .icon-update-btn .fa-pencil {
  font-size: 18px;
}
.media-event-update-section .custom-container .content-section .content-body .media-icon-container .image-uploader .icon-update-btn:hover {
  background: gray;
}
.media-event-update-section .custom-container .content-section .content-body .media-image-container {
  position: relative;
  height: 350px;
  background: #f7f7f7;
}
.media-event-update-section .custom-container .content-section .content-body .media-image-container .image-uploader {
  position: absolute;
  top: -20px;
  right: -20px;
}
.media-event-update-section .custom-container .content-section .content-body .media-image-container .image-uploader .icon-update-btn {
  height: 50px;
  width: 50px;
  background: #b4b4b4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: 0.4s;
}
.media-event-update-section .custom-container .content-section .content-body .media-image-container .image-uploader .icon-update-btn .fa-pencil {
  font-size: 18px;
}
.media-event-update-section .custom-container .content-section .content-body .media-image-container .image-uploader .icon-update-btn:hover {
  background: gray;
}

.custom-media-and-events-card {
  height: 430px;
  background: #fff;
  max-width: 300px;
  padding: 1rem;
  border-radius: 12px;
  margin: 0 auto 1.5rem auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
@media (max-width: 325px) {
  .custom-media-and-events-card {
    height: 500px;
  }
}
@media (min-width: 1200px) and (max-width: 1295px) {
  .custom-media-and-events-card {
    height: 500px;
  }
}
.custom-media-and-events-card .custom-media-and-events-card-header {
  background: #f7f7f7;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
}
.custom-media-and-events-card .custom-media-and-events-card-header img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
.custom-media-and-events-card .custom-media-and-events-card-body {
  height: 115px;
  margin-top: 0.8rem;
  border-top: 2px solid #ebebeb;
  padding-top: 0.5rem;
}
.custom-media-and-events-card .custom-media-and-events-card-body .media-and-events-card-name {
  color: #525252;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
@media (max-width: 325px) {
  .custom-media-and-events-card .custom-media-and-events-card-footer .delete-btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
@media (min-width: 1200px) and (max-width: 1295px) {
  .custom-media-and-events-card .custom-media-and-events-card-footer .delete-btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
@media (max-width: 325px) {
  .custom-media-and-events-card .custom-media-and-events-card-footer .save-btn {
    width: 100%;
    margin-left: 0 !important;
  }
}
@media (min-width: 1200px) and (max-width: 1295px) {
  .custom-media-and-events-card .custom-media-and-events-card-footer .save-btn {
    width: 100%;
    margin-left: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/mediaEvent/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAKI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJN;AAMM;EACE,iBCEK;EDDL,kBAAA;EACA,cAAA;AAJR;AAMQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAJV;AAQM;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yCAAA;AANR;AAQQ;EARF;IASI,kBAAA;EALR;AACF;AAOQ;EACE,qBAAA;AALV;AAUU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AARZ;AAWU;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AATZ;AAWY;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AATd;AAWc;EACE,eAAA;AAThB;AAYc;EACE,gBAAA;AAVhB;AAgBQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAdV;AAgBU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAdZ;AAgBY;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAdd;AAgBc;EACE,eAAA;AAdhB;AAiBc;EACE,gBAAA;AAfhB;;AAyBA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,0CAAA;AAtBF;AAwBE;EATF;IAUI,aAAA;EArBF;AACF;AAuBE;EAbF;IAcI,aAAA;EApBF;AACF;AAsBE;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AApBN;AAwBE;EACE,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAtBN;AA4BM;EADF;IAEI,WAAA;IACA,qBAAA;EAzBN;AACF;AA2BM;EANF;IAOI,WAAA;IACA,qBAAA;EAxBN;AACF;AA4BM;EADF;IAEI,WAAA;IACA,yBAAA;EAzBN;AACF;AA2BM;EANF;IAOI,WAAA;IACA,yBAAA;EAxBN;AACF","sourcesContent":["@import \"../../../../assets/css/common/variables\";\r\n\r\n.media-event-update-section {\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 1rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        margin: 2rem auto 0;\r\n        max-width: 900px;\r\n        border-radius: 4px;\r\n        padding: 5rem .5rem;\r\n        background: #fff;\r\n        box-shadow: 0 6px 6px rgba(0, 0, 0, .06);\r\n\r\n        @media (min-width: 768px) {\r\n          padding: 5rem 4rem;\r\n        }\r\n\r\n        .form__div-container {\r\n          margin-bottom: 2.5rem;\r\n        }\r\n\r\n        .media-icon-container {\r\n\r\n          .media-icon {\r\n            height: 100px;\r\n            width: 100px;\r\n            object-fit: contain;\r\n          }\r\n\r\n          .image-uploader {\r\n            position: absolute;\r\n            top: -30px;\r\n            left: 105px;\r\n\r\n            .icon-update-btn {\r\n              height: 40px;\r\n              width: 40px;\r\n              background: #b4b4b4;\r\n              color: #fff;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              border-radius: 100%;\r\n              cursor: pointer;\r\n              transition: .4s;\r\n\r\n              .fa-pencil {\r\n                font-size: 18px;\r\n              }\r\n\r\n              &:hover {\r\n                background: gray;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .media-image-container {\r\n          position: relative;\r\n          height: 350px;\r\n          background: #f7f7f7;\r\n\r\n          .image-uploader {\r\n            position: absolute;\r\n            top: -20px;\r\n            right: -20px;\r\n\r\n            .icon-update-btn {\r\n              height: 50px;\r\n              width: 50px;\r\n              background: #b4b4b4;\r\n              color: #fff;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              border-radius: 100%;\r\n              cursor: pointer;\r\n              transition: .4s;\r\n\r\n              .fa-pencil {\r\n                font-size: 18px;\r\n              }\r\n\r\n              &:hover {\r\n                background: gray;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.custom-media-and-events-card {\r\n  height: 430px;\r\n  background: #fff;\r\n  max-width: 300px;\r\n  padding: 1rem;\r\n  border-radius: 12px;\r\n  margin: 0 auto 1.5rem auto;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\r\n\r\n  @media (max-width: 325px) {\r\n    height: 500px;\r\n  }\r\n\r\n  @media (min-width: 1200px) and (max-width: 1295px) {\r\n    height: 500px;\r\n  }\r\n\r\n  .custom-media-and-events-card-header {\r\n    background: #f7f7f7;\r\n    height: 200px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 12px;\r\n\r\n    img {\r\n      width: 100px;\r\n      height: 100px;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  .custom-media-and-events-card-body {\r\n    height: 115px;\r\n    margin-top: 0.8rem;\r\n    border-top: 2px solid #ebebeb;\r\n    padding-top: 0.5rem;\r\n\r\n    .media-and-events-card-name {\r\n      color: #525252;\r\n      font-size: 1rem;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      display: -webkit-box;\r\n      -webkit-line-clamp: 5;\r\n      -webkit-box-orient: vertical;\r\n    }\r\n  }\r\n\r\n  .custom-media-and-events-card-footer {\r\n    .delete-btn {\r\n      @media (max-width: 325px) {\r\n        width: 100%;\r\n        margin-bottom: .5rem;\r\n      }\r\n\r\n      @media (min-width: 1200px) and (max-width: 1295px) {\r\n        width: 100%;\r\n        margin-bottom: .5rem;\r\n      }\r\n    }\r\n\r\n    .save-btn {\r\n      @media (max-width: 325px) {\r\n        width: 100%;\r\n        margin-left: 0 !important;\r\n      }\r\n\r\n      @media (min-width: 1200px) and (max-width: 1295px) {\r\n        width: 100%;\r\n        margin-left: 0 !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
